import type { PagingBaseProps, PagingBaseState, PagingPage, HasId } from "./PagingBaseComponent";
import { PagingBaseComponent } from "./PagingBaseComponent";

export default PagingBaseComponent;
export type { PagingBaseProps, PagingBaseState, PagingPage, HasId };
